export const ProductConstants = {
    PRODUCT_ADDED_REQUEST:'PRODUCT_ADDED_REQUEST',
    PRODUCT_ADDED_SUCCESS:'PRODUCT_ADDED_SUCCESS',
    PRODUCT_ADDED_FAILURE:'PRODUCT_ADDED_FAILURE',

    PRODUCT_GET_REQUEST:'PRODUCT_GET_REQUEST',
    PRODUCT_GET_SUCCESS:'PRODUCT_GET_SUCCESS',
    PRODUCT_GET_FAILURE:'PRODUCT_GET_FAILURE',

    SINGLE_PRODUCT_GET_REQUEST:'SINGLE_PRODUCT_GET_REQUEST',
    SINGLE_PRODUCT_GET_SUCCESS:'SINGLE_PRODUCT_GET_SUCCESS',
    SINGLE_PRODUCT_GET_FAILURE:'SINGLE_PRODUCT_GET_FAILURE',


    SINGLE_PRODUCT_UPDATE_REQUEST:'SINGLE_PRODUCT_UPDATE_REQUEST',
    SINGLE_PRODUCT_UPDATE_SUCCESS:'SINGLE_PRODUCT_UPDATE_SUCCESS',
    SINGLE_PRODUCT_UPDATE_FAILURE:'SINGLE_PRODUCT_UPDATE_FAILURE',

    DELETE_MY_PRODUCT_REQUEST:'DELETE_MY_PRODUCT_REQUEST',
    DELETE_MY_PRODUCT_SUCCESS:'DELETE_MY_PRODUCT_SUCCESS',
    DELETE_MY_PRODUCT_FAILURE:'DELETE_MY_PRODUCT_FAILURE',


    GET_PRODUCT_ATTRIBUTE_REQUEST : 'GET_PRODUCT_ATTRIBUTE_REQUEST',
    GET_PRODUCT_ATTRIBUTE_SUCCESS : 'GET_PRODUCT_ATTRIBUTE_SUCCESS',
    GET_PRODUCT_ATTRIBUTE_FAILURE : 'GET_PRODUCT_ATTRIBUTE_FAILURE',




};
